<template>
  <div>
    <v-container>
      <div class="text-xs-right">
        <div>
          <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>search</v-btn>
        </div>
        <importxlsx :loading="importloading" @onChange="onImport"></importxlsx>
        <v-btn color="grey" outline @click="showExportGroup = true">
          <em class="fas fa-file-export" />
          &nbsp; Export&nbsp;
        </v-btn>
        <v-btn depressed color="primary" @click="addData">ADD</v-btn>
      </div>
      <v-pagination
        v-model="pageNumber"
        :total-visible="15"
        :length="pagelength"
        @input="changePage"
      ></v-pagination>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        hide-actions
        :pagination.sync="pagination"
        class="elevation-1"
      >
        <template #items="props">
          <tr>
            <td>
              {{ props.item.imei }}
            </td>
            <td>
              {{ props.item.points }}
            </td>
            <td>
              {{ props.item.description }}
            </td>
            <td>
              <span v-if="props.item.status" style="font-weight: bold; color: limegreen">
                แลกแล้ว
              </span>
              <span v-else style="font-weigh: bold; color: grey">ยังไม่แลก</span>
            </td>

            <td class="text-xs-right">
              <v-btn icon @click="oneditData(props.item)"> <v-icon>edit</v-icon></v-btn>
              <v-btn icon @click="ondeleteData(props.item)"> <v-icon>delete</v-icon></v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div>
        <v-dialog v-model="showEdit" persistent width="550px">
          <v-card v-if="showEdit">
            <ImeiEdit
              :edittype="edittype"
              :editdata="editdata"
              @onsave="onsave"
              @close="showEdit = false"
            ></ImeiEdit>
          </v-card>
        </v-dialog>
      </div>

      <v-dialog v-model="showsearch" width="500px" persistent>
        <v-card>
          <div style="float: right">
            <v-btn icon @click="showsearch = false"><v-icon>close</v-icon></v-btn>
          </div>
          <div class="pa-2 pt-4 pb-3">
            <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
            <div>
              <v-layout class="pa-0 ma-0" wrap row>
                <v-flex xs12 sm6 class="form-control pa-1">
                  <label>{{ $t('เลข IMEI') }}</label>
                  <input v-model="filter.imei" class="form-control" type="text" />
                </v-flex>
                <v-flex xs12 sm6 class="form-control pa-1">
                  <label>{{ $t('ข้อมูลเครื่อง') }}</label>
                  <input v-model="filter.description" class="form-control" type="text" />
                </v-flex>
                <v-flex xs6 sm6 class="form-control pa-1">
                  <label>{{ $t('สถานะการ Scan') }}</label>
                  <multiselect
                    v-model="filter.status"
                    :show-labels="false"
                    label="text"
                    :options="scanstatusoptions"
                  ></multiselect>
                </v-flex>

                <!-- <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('สาขา') }}</label>
                <input v-model="filter.branch" class="form-control" type="text" />
              </v-flex> -->
              </v-layout>
            </div>
            <div class="text-xs-center">
              <v-btn outline color="grey" @click="clearsearch">Clear</v-btn>
              <v-btn color="primary" @click="onsearch">Search</v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </v-container>
    <v-dialog v-model="reasondialog" width="500px">
      <v-card>
        <div class="pa-3 px-5">
          <div class="pb-3" style="font-weight: 600; font-size: 19px">เลข IMEI ซ้ำ</div>
          <div v-for="(item, k) in reason" :key="k">Row ที่ {{ item }}</div>
          <div class="text-center">
            <v-btn color="primary" @click="reasondialog = false">ปิด</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <ExportGroup
      v-model="showExportGroup"
      :total="total"
      filename="imei-lists"
      :limit="100000"
      @onExport="onExportImei"
    ></ExportGroup>
  </div>
</template>

<script>
import api from '@/api'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import ImeiEdit from './ImeiEdit.vue'
import ExportGroup from '@/components/elements/ExportGroup.vue'
import VueQr from 'vue-qr'
import XLSX from 'xlsx'

export default {
  components: {
    ImeiEdit,
    VueQr,
    importxlsx,
    exportxlsx,
    multiselect,
    ExportGroup
  },
  data() {
    return {
      reason: '',
      reasondialog: false,
      scanstatusoptions: [
        { text: 'แลกแล้ว', value: true },
        { text: 'ยังไม่แลก', value: false }
      ],
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      qrlink: '',
      qrdialog: false,
      importloading: false,
      qrdata: '',
      showEdit: false,
      editdata: '',
      edittype: '',

      pagination: { rowsPerPage: -1, sortBy: 'branch_id' },
      columnName: '',
      items: [],
      filter: {
        imei: '',
        description: '',
        status: ''
      },
      exportloading: false,
      showsearch: false,
      loading: false,
      headers: [
        { text: 'เลข IMEI', value: 'imei' },
        { text: 'เครื่องที่ได้รับ', value: 'points' },
        { text: 'ข้อมูลเครื่อง', value: 'description' },
        { text: 'สถานะการ Scan', value: 'status' },

        { text: '', value: '' }
      ],
      showExportGroup: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async onExportImei(callback) {
      const vm = this
      try {
        if (callback) {
          vm.$store.dispatch('loading')
          let { limit, offset } = callback
          const response = await vm.getYasaleImei(limit, offset)
          const exportItems = response.data

          if (exportItems === null) return

          const json = exportItems.map((el) => {
            return {
              'เลข IMEI': el.imei,
              ข้อมูลเครื่อง: el.description,
              เครื่องที่ได้รับ: el.points
            }
          })

          const dataWS = XLSX.utils.json_to_sheet(json)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, `export-imei.xlsx`)
          vm.$store.commit('CLEAR_LOADING')
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    async getData() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getYasaleImei(this.limit, this.offset)
        vm.$store.commit('CLEAR_LOADING')

        if (response) {
          this.items = response.data
          this.total = response.total
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    async getYasaleImei(limit, offset) {
      const data = {
        pageid: this.selectedBot.pageid,
        limit: limit,
        offset: offset
      }

      for (const key in this.filter) {
        if (this.filter[key]) {
          if (key == 'status') {
            Object.assign(data, { [key]: this.filter[key].value })
          } else {
            Object.assign(data, { [key]: this.filter[key] })
          }
        }
      }

      return new Promise((resolve, reject) => {
        api.getYasaleImei(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }

          if (response) {
            resolve(response)
          }
        })
      })
    },
    ondeleteData(item) {
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            this.loading = true
            var data = {
              ...item,
              pageid: this.selectedBot.pageid
            }
            api.deleteYasaleImei(data, (err, response) => {
              this.loading = false
              if (response.responsecode == 200) {
                this.getData()
                this.$swal.fire({
                  type: 'success',
                  text: 'สำเร็จ'
                })
              }
            })
          }
        })
    },
    clearsearch() {
      this.filter = {
        branchId: '',
        branchToaId: '',
        departmentStore: ''
      }
      this.getData()
      this.showsearch = false
    },
    onsearch() {
      this.getData()
      this.showsearch = false
    },
    onImport(item) {
      this.importloading = true
      var data = {
        pageid: this.selectedBot.pageid,
        files: item[0]
      }

      api.importYasaleImei(data, async (response) => {
        this.importloading = false

        if (response.responsecode == 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
        } else {
          this.reason = response.reason.split('Row ที่ ')
          this.reason.splice(0, 1)
          this.reasondialog = true
        }
        this.getData()
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    oneditData(item) {
      this.editdata = item
      this.edittype = 'edit'
      this.showEdit = true
    },
    onsave() {
      this.showEdit = false
      this.getData()
    },
    gotolink(link) {
      this.$nextTick(() => {
        window.location.href = link
      })
      // location.assign(this.qrlink)
    },
    showQrcode(item) {
      this.qrdialog = true
      this.qrdata = item
    },
    addData() {
      this.edittype = 'create'
      this.showEdit = true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/yasale/imei/main.vue